module.exports = __webpack_public_path__ + "static/media/whiteLogo.f75f441d.png";